

  import axios from 'axios';
  import { Component, Vue } from 'vue-property-decorator';
  import {authService} from '../../olsStateManagement/services/auth.service';
  import BrowserDetector from '../../olsStateManagement/helpers/browserDetector'
  import {DEFAULT_ROOT_URL, API_UNAVAILABLE_MESSAGE} from '../../olsStateManagement/helpers/constants'

  const browserDetector = new BrowserDetector();
  // const authService = new AuthService();

  @Component({
    components: {}
  })

  export default class App extends Vue {

    public accessTokenExpired: boolean | undefined = false;
    public isAuthorized: boolean = false;
    public currentOlsUser: any = {}
    public labels: any = {}
    public userName: string = ""
    public emailVerified: boolean = false;
    public haveAccount: boolean = true;
    public isBrowserCompatible:boolean = false;
    public isApiUnavailable:boolean = false;

    public isError: boolean = false;
    public errorMessage: string = "";

    public loader: any = {
      loaded: false,
      loading: false
    }

    public apiUnavailableMessage: any = {
      title: API_UNAVAILABLE_MESSAGE.title,
      description: API_UNAVAILABLE_MESSAGE.description
    }

    public signUp() {
      authService.signUp();
    }

    public login() {
      authService.login();
    }

    public logout() {
      authService.logout();
    }

    public mounted() {
      this.loader.loading = true;
      this.isBrowserCompatible = browserDetector.isSupported();
      authService.getUser()
        .then((user:any) => {
          if(user) {
            if(user.profile.email_verified) {
              this.isAuthorized = authService.isAuthorized();

              if(this.isAuthorized) {
                this.userName = user.profile.nickname != null ? user.profile.nickname : user.profile.name;

                let pOlsUser = sessionStorage.getItem('olsUser')
                if(pOlsUser){
                  let olsUser = JSON.parse(pOlsUser);
                  console.log(olsUser)
                  if(olsUser.error){
                    if(olsUser.error.hasError){
                      this.isError = true;
                      this.errorMessage = olsUser.error.error;
                    }
                  }else{
                    this.isError = false;
                  }
                }

              }
              else {
                this.logout();
              }
            }
          }
        })
        .catch(error => console.log(error))

      this.getLabels();

    }

    public retryIfApiUnavailable: number = 0;

    public getLabels(){
      axios.get('olsUserProfile/getHomePageModuleLabels')
          .then(response => {
            this.labels = JSON.parse(JSON.stringify(response.data));
            // IF DATA IS LOADED FROM API SUCCESSFULLY, STOP THE LOADER
            this.loader.loading = false;
          })
          .catch(error => {
             // DISABLE AUTH BUTTONS IF CONNECTION TO API IS LOST OR UNAVAILABLE
              if (!error.response) {
                  // network error
                  if(this.retryIfApiUnavailable < 4){
                    this.getLabels();
                    this.retryIfApiUnavailable++
                  }else{
                    this.isApiUnavailable = true;
                    // IF API IS UNAVAILABLE AFTER 3 TIMES STOP THE LOADER AND SHOW NOTIFICATION
                    this.loader.loading = false
                  }
              } else {
                  console.log(error.response.data.message);
              }
          })
          .finally(() => {
            // home page loader
            // setTimeout(() => {
            //   if((this.isApiUnavailable && this.retryIfApiUnavailable == 3) || !this.isApiUnavailable) {
            //     this.loader.loading = false
            //   }
            // }, 3000)
          })
    }

    redirectToUrl(url: string) {
      return window.location.href = DEFAULT_ROOT_URL + url;
    }

  }

